const paramBase = clientConfigId => {
  return `tds-pc-${clientConfigId}`;
};

const createParam = (clientConfigId, nestedParamNames) => {
  let param = paramBase(clientConfigId);

  for (const nestedParamName of nestedParamNames) {
    param = `${param}[${nestedParamName}]`;
  }

  return param;
};

export { createParam, paramBase };
